const PrimaryBadge = () => (
    <p className={'rounded-full bg-blue-50 px-2 py-1 text-xs text-blue-500'}>Primary</p>
);

export { PrimaryBadge };
